import { useState } from 'react';
import { Container } from './styled';
import { Charts, ChartFull } from '../../../../../components';
import { RiFileExcel2Fill } from "react-icons/ri";
import { GiResize } from "react-icons/gi";
import * as XLSX from 'xlsx';

const CATEGORY_CONFIG = {
    MARKETING: {
        label: 'MARKETING',
        color: '#8B5CF6',
    },
    SERVICE: {
        label: 'SERVICE',
        color: '#06B6D4',
    },
    UTILITY: {
        label: 'UTILITY',
        color: '#F59E0B',
    },
    MI4U: {
        label: 'MI4U',
        color: '#1d86ff',
    },
};

export function ChartCompany({ company, objKey, className, activeTab }) {
    const { empresa_nome, empresa_avatar, dados, mensagens } = company;

    const [openFullChart, setOpenFullChart] = useState(false);
    const [openFullChartMsg, setOpenFullChartMsg] = useState(false);

    const generateChartData = (dataCompany) => {
        if (!dataCompany || dataCompany.length === 0) return null;
        const objGrouped = dataCompany.reduce((accumulator, obj) => {
            const { ...data } = obj;
            if (!accumulator[obj[objKey]]) {
                accumulator[obj[objKey]] = [];
            }
            accumulator[obj[objKey]].push(data);
            return accumulator;
        }, {});
        const labels = Object.keys(objGrouped);
        const tempoValues = Object.values(objGrouped).map(item => {
            if (item[0] !== undefined && item[0].tempo_minutos !== undefined) {
                return item[0].tempo_minutos;
            } else {
                return 0;
            }
        });

        const chartData = {
            labels: labels,
            datasets: [
                {
                    label: 'Minutos em Video',
                    data: tempoValues,
                    backgroundColor: 'rgba(255, 99, 132, 1)',
                    borderColor: 'rgba(255, 99, 132, 1)',
                    borderWidth: 2,
                    fill: false,
                },
            ],
        };
        return chartData;
    };

    const generateMessageChartData = (mensagensData) => {
        if (!mensagensData || mensagensData.length === 0) return null;

        const labels = mensagensData.map(item => item.mes_extenso);

        const categories = ['MARKETING', 'SERVICE', 'UTILITY'];

        const labelPositions = [
            { anchor: 'end', align: 'top', offset: 6 },
            { anchor: 'start', align: 'bottom', offset: 6 },
            { anchor: 'end', align: 'right', offset: 8 },
        ];

        const datasets = categories.map((catKey, index) => {
            const config = CATEGORY_CONFIG[catKey];
            const pos = labelPositions[index];
            const data = mensagensData.map(mesItem => {
                const categorias = mesItem.categorias || [];
                const found = categorias.find(c => c.categoria === catKey);
                return found ? (found.volume || 0) : 0;
            });

            return {
                label: config.label,
                data,
                backgroundColor: config.color,
                borderColor: config.color,
                borderWidth: 2,
                fill: false,
                tension: 0.3,
                pointRadius: 4,
                pointHoverRadius: 6,
                datalabels: {
                    anchor: pos.anchor,
                    align: pos.align,
                    offset: pos.offset,
                },
            };
        });

        const mi4uConfig = CATEGORY_CONFIG.MI4U;
        const mi4uData = mensagensData.map(mesItem => mesItem.total || 0);
        datasets.push({
            label: mi4uConfig.label,
            data: mi4uData,
            backgroundColor: mi4uConfig.color,
            borderColor: mi4uConfig.color,
            borderWidth: 2,
            fill: false,
            tension: 0.3,
            pointRadius: 4,
            pointHoverRadius: 6,
            datalabels: {
                anchor: 'start',
                align: 'left',
                offset: 8,
            },
        });

        return {
            labels,
            datasets,
        };
    };

    const generateExportExcel = (data) => {
        if (!data || !data.labels || data.labels.length === 0) return;

        const categories = ['MARKETING', 'SERVICE', 'UTILITY', 'MI4U'];

        const dataToExport = data.labels.map((mes, index) => {
            const row = {
                'Mês': mes,
            };

            categories.forEach(category => {
                const dataset = data.datasets?.find(d => d.label === category);
                row[category] = dataset ? (dataset.data?.[index] ?? 0) : 0;
            });

            return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Consumo Mensagens');

        worksheet['!cols'] = [
            { wch: 18 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
        ];

        const sanitizedCompanyName = empresa_nome ? `${empresa_nome.trim().replace(/[/\\?%*:|"<>]/g, '_')} - ` : '';
        XLSX.writeFile(workbook, `${sanitizedCompanyName}Consumo Mensagens.xlsx`);
    };

    const chartData = generateChartData(dados);
    const messageChartData = generateMessageChartData(mensagens);

    return (
        <>
            <Container className={className}>
                <div className='info--'>
                    <div className='logo--'>
                        <img
                            src={empresa_avatar}
                            alt={`avatar--`}
                        />
                    </div>
                    <div className='name--company'>
                        <span>
                            {` - ${empresa_nome}`}
                        </span>
                    </div>
                </div>

                {activeTab === 'message' && messageChartData && messageChartData.labels.length > 0 && (
                    <>
                        <div className='full--'>
                            <span title="Exportar para Excel" onClick={() => { generateExportExcel(messageChartData) }}>
                                <RiFileExcel2Fill fontSize={'1.75rem'} />
                            </span>
                            <span onClick={() => setOpenFullChartMsg(true)}>
                                <GiResize fontSize={'1.75rem'} />
                            </span>
                        </div>
                        <div className='--chart'>
                            <Charts
                                type='Line'
                                data={messageChartData}
                            />
                        </div>
                    </>
                )}

                {activeTab === 'video' && chartData && chartData.labels.length > 0 && (
                    <>
                        <div className='full--'>
                            <span onClick={() => setOpenFullChart(true)}>
                                <GiResize fontSize={'1.75rem'} />
                            </span>
                        </div>
                        <div className='--chart'>
                            <Charts
                                type='Line'
                                data={chartData}
                            />
                        </div>
                    </>
                )}
            </Container >

            {
                (openFullChart) && chartData &&
                (<ChartFull
                    onClose={() => setOpenFullChart(false)}
                    title={`${empresa_nome}`}
                    dataChart={
                        {
                            type: "Line",
                            data: chartData
                        }
                    }
                />)
            }
            {
                (openFullChartMsg) && messageChartData &&
                (<ChartFull
                    onClose={() => setOpenFullChartMsg(false)}
                    title={`${empresa_nome} - Mensagens`}
                    dataChart={
                        {
                            type: "Line",
                            data: messageChartData
                        }
                    }
                />)
            }
        </>
    );
}